import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { Query } from 'react-apollo'
import Slider from 'react-slick'
import Lightbox from 'react-images'
import {
  H1, H2, P, H5, Div, H3, H4, Icon, ButtoWhiteHoverGreen, ButtoGhostActiveWhite, ButtonGreenHoverWhite,
} from 'konsys-ui'
import { ContainerWithoutHeader, Header } from '../../components/container'
import history from '../../history'
import PATH from '../../constants/path'
import {
  SHOW_BANNER, SHOW_GALLERY, SHOW_POPUP,
  SHOW_PACKAGE,
} from '../../constants/graph/query'
import { WidthContainer } from '../../components/container/styled'
import { PackageContent } from '../package-page/list'
import { PackageContainer } from '../package-page/list/styled'
import {
  QuotationRequestSection, PrintingTechnique, PrintingImage, PrintingMachineImg,
  PrintingMachineWrapper, Line, DesignServiceWrapper, BlueBoxImg, WhatWeDoWrapper,
  IconImg, WhiteBoxImg, PortFolioImageWrapper, PortFolioWrapper, PackagingWrapper, BannerWrapper, PopupContainerWrapper,
  PopupWrapper, ArrowTextWrapper, ArrowIconWrapper, LinkText, DivPackage, PortFolioImgBg, PackageWidthContainer,
  DivPackageDefault,
} from './styled'
import { theme, screenSize } from '../../styles/_variables'
import Emboss from '../../images/printing-information/Printing-Techniques/1-1_Embossing.jpg'
import Foil from '../../images/printing-information/Printing-Techniques/1-3_Foiling_03.jpg'
import Uv from '../../images/printing-information/Printing-Techniques/2-4-1_Spot_UV_Glossy_01.jpg'
import Matt from '../../images/printing-information/Printing-Techniques/2-3-2_OPP_Matt_02.jpg'
import PrintingMachine from '../../images/home/Printery_Machine.png'
import BlueBox from '../../images/home/Blue_Box_with_a_Cup.png'
import Detail1 from '../../images/home/Detail_Icon_01.png'
import Detail2 from '../../images/home/Detail_Icon_02.png'
import Detail3 from '../../images/home/Detail_Icon_03.png'
import Detail4 from '../../images/home/Detail_Icon_04.png'
import Detail1Hover from '../../images/home/Detail_Icon_01_hovered.png'
import Detail2Hover from '../../images/home/Detail_Icon_02_hovered.png'
import Detail3Hover from '../../images/home/Detail_Icon_03_hovered.png'
import Detail4Hover from '../../images/home/Detail_Icon_04_hovered.png'
import WhiteBox from '../../images/home/White_Boxes.png'

const printingTechniqueData = [
  {
    text: 'ปั๊มนูน',
    img: Emboss,
  }, {
    text: 'ปั๊มทองเค',
    img: Foil,
  }, {
    text: 'การเคลือบยูวีเฉพาะจุด',
    img: Uv,
  }, {
    text: 'การเคลือบพลาสติกแบบด้าน',
    img: Matt,
  },
]

const whatWeDo = [
  {
    title: 'ออกแบบกล่องบรรจุภัณฑ์',
    text: 'เราสามารถช่วยคุณสร้างสรรค์กล่องบรรจุภัณฑ์ ให้มีความสวยงาม เหมาะสมกับผลิตภัณฑ์ของคุณ',
    img: Detail1,
    imgHover: Detail1Hover,
  }, {
    title: 'โรงพิมพ์ครบวงจร',
    text: 'เราผลิตงานพิมพ์คุณภาพโดยใช้เทคโนโลยีเครื่องจักร วัสดุ อุปกรณ์การพิมพ์ต่างๆที่ทันสมัย ครบวงจร เพื่อการผลิตที่รวดเร็วและมีคุณภาพ',
    img: Detail2,
    imgHover: Detail2Hover,
  }, {
    title: 'ฟรี! จัดส่งทั่วประเทศ',
    text: 'เราบริการจัดส่งชิ้นงานของคุณทั่วประเทศ โดยไม่คิดค่าใช้จ่ายใดๆ',
    img: Detail3,
    imgHover: Detail3Hover,
  }, {
    title: 'งานพิมพ์คุณภาพ',
    text: 'เรารับประกันคุณภาพทุกชิ้นงาน ด้วยการให้บริการอย่างซื่อสัตย์ รับผิดชอบ จริงใจ และคำนึงถึงความพึงพอใจของลูกค้าเป็นสำคัญ',
    img: Detail4,
    imgHover: Detail4Hover,
  },
]

const ArrowText = props => (
  <ArrowTextWrapper {...props}>
    <P color={theme.color.grey} style={{
      borderBottom: `1px solid ${theme.color.grey}`,
    }}>{props.text}</P>
  </ArrowTextWrapper>
)

const ArrowIcon = props => (
  <ArrowIconWrapper {...props}>
    <Icon
        fontSize={theme.fonts.size.heading}
        color={theme.color.paleGray}
        icon={props.icon}
      />
  </ArrowIconWrapper>
)

const Popup = ({ data }) => {
  const [showPopup, setShowPopup] = useState(!_.isEmpty(data))

  if (!showPopup) {
    return null
  }

  return (
    <PopupContainerWrapper onClick={(e) => {
      if (!this.popupContent.contains(e.target)) {
        setShowPopup(false)
      }
    }}>
      <PopupWrapper innerRef={(el) => { this.popupContent = el }}>
        <Icon color={theme.color.offWhite} icon='fal fa-times-circle' onClick={() => setShowPopup(false)} />
        <img src={data.popUpFileUri} />
      </PopupWrapper>
    </PopupContainerWrapper>
  )
}

const PackageCard = ({
  data,
  onClick,
}) => {
  const file = data.packageFiles.filter(item => item.type === 'cover')
  const {
    name,
    ordering,
  } = data
  return (
    <DivPackage onClick={onClick}>
      <PackageContent ordering={ordering} file={file} name={name} />
    </DivPackage>
  )
}

const PackageCardDefault = ({
  data,
  onClick,
}) => {
  const file = data.packageFiles.filter(item => item.type === 'cover')
  const {
    name,
    ordering,
  } = data
  return (
    <DivPackageDefault onClick={onClick}>
      <PackageContent ordering={ordering} file={file} name={name} />
    </DivPackageDefault>
  )
}

const Image = ({ img, onClick }) => (
  <PortFolioImageWrapper onClick={() => onClick()}>
    <PortFolioImgBg img={img} />
    <Icon icon='far fa-search-plus' />
  </PortFolioImageWrapper>
)


const Home = (props) => {
  const [windowSize, setWindowSize] = useState(window.innerWidth)
  const [isShowModal, setIsShowModal] = useState(false)
  const [openLightBox, setOpenLightBox] = useState(false)
  const [currentImage, setCurrentImage] = useState(0)

  useEffect(() => {
    window.addEventListener('resize', () => {
      setWindowSize(window.innerWidth)
      if (this.slick) {
        this.slick.innerSlider.onWindowResized()
      }
    })
  })

  const isTablet = windowSize <= screenSize.tablet
  const isMobileL = windowSize <= screenSize.mobileL
  const isTabletS = windowSize <= screenSize.tabletS
  const isLaptop = windowSize <= screenSize.laptop
  const isMobileXL = windowSize <= screenSize.mobileXL
  const isMobileM = windowSize <= screenSize.mobileM

  const bannerSlideSetting = {
    className: 'banner',
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: screenSize.tablet,
        settings: {
          dots: true,
          nextArrow: null,
          prevArrow: null,
        },
      },
    ],
  }

  return (
    <ContainerWithoutHeader isHome blur={isShowModal}>
      <Div moreStyle={{
        position: 'absolute',
        top: isTablet ? 0 : isLaptop ? '24px' : '64px',
        left: isTablet ? 0 : isLaptop ? '24px' : 0,
        right: isTablet ? 0 : isLaptop ? '24px' : 0,
        textAlign: 'center',
      }}>
        <Header isShowModal={value => setIsShowModal(value)} />
      </Div>
      <BannerWrapper>
      <Query
        query={SHOW_BANNER}
      >
      {
        ({ loading, data }) => {
          if (loading || !data) return null
          return (
            <Slider {...bannerSlideSetting} ref={(el) => { this.slick = el }}>
            {
              data.showBanner.banner.map(v => (
                <Div key={v.bannerId} moreStyle={{
                  overflow: 'hidden !important',
                }}>
                  <img style={{
                    objectFit: 'cover',
                    width: isMobileM ? '160%' : isMobileXL ? '130%' : isTablet ? '120%' : '100%',
                    transform: isTablet && 'scale(1.4) translate(-3%, -8%)',
                  }} src={v.bannerFileUri} />
                </Div>
              ))
            }
            </Slider>
          )
        }
      }
      </Query>
      </BannerWrapper>
      <WhatWeDoWrapper>
        <WidthContainer>
          <Div display='flex' margin={isTablet ? '0 0 32px' : '0 0 56px'}>
            {
              !isTablet
              && <Div flexBasis='50%'>
                <WhiteBoxImg src={WhiteBox} />
              </Div>
            }
            <Div flexBasis={isTablet ? '100%' : '50%'}>
              <H1 margin={isTablet ? '0 0 24px' : '0 0 32px'} color={theme.color.secondaryColor}>boxsuit ผลิตกล่องคุณภาพ</H1>
              <H4
                style={{ fontWeight: 'normal', fontSize: '24px' }}
                color={theme.color.lightGrey}
              >{`boxsuit คือผู้ให้บริการสร้างสรรค์กล่องบรรจุภัณฑ์คุณภาพ แต่ละชิ้นงานถูกรังสรรค์ขึ้นโดยคำนึงถึงความเหมาะสมของการบรรจุสินค้าและส่งเสริมแบรนด์สินค้าตามความต้องการ
               ด้วยบริการงานพิมพ์แบบครบวงจรที่มีมาตรฐานและรวดเร็ว ตั้งแต่บริการออกแบบ การผลิต และการจัดส่ง`}</H4>
              {
                !isTablet
                && <Div margin='24px 0 0' textAlign='right'>
                  <Link to={PATH.request}>
                    <ButtoWhiteHoverGreen color={theme.color.primaryColor} text='ขอใบเสนอราคา' />
                  </Link>
                </Div>
              }
            </Div>
          </Div>
          <Div display='flex' flexDirection={isTablet && 'column'} moreStyle={{ flexWrap: 'wrap' }}>
          {
            whatWeDo.map((v, i) => (
              <Div
                key={v.title}
                display='flex'
                alignItems='flex-start'
                flexBasis={isTablet ? '100%' : 'calc((100% - 120px) / 2)'} margin={isTablet ? '0 0 24px' : i === 0 ? '0 120px 48px 0' : i === 1 ? '0 0 48px 0' : i === 2 ? '0 120px 0 0' : '0'}
                moreStyle={{
                  minHeight: isTabletS ? 'auto' : isTablet ? '100px' : 'auto',
                }}
              >
                <Div flexBasis={isTabletS ? '20%' : isTablet ? '12%' : '20%'}>
                  <IconImg src={v.img} onMouseOver={e => e.target.setAttribute('src', v.imgHover)} onMouseOut={e => e.target.setAttribute('src', v.img)} />
                </Div>
                <Div flexBasis='75%' margin='0 0 0 16px'>
                  <H4 margin={isTablet ? '0 0 8px' : '0 0 16px'}>{v.title}</H4>
                  <H5 className="text" color={theme.color.lightPaleGrey}>{v.text}</H5>
                </Div>
              </Div>
            ))
          }
          </Div>
          {
            isTablet && <Link to={PATH.request}>
            <ButtoWhiteHoverGreen fullWidth color={theme.color.primaryColor} text='ขอใบเสนอราคา' />
          </Link>
          }
        </WidthContainer>
      </WhatWeDoWrapper>
      <Query
        query={SHOW_PACKAGE}
        variables={{
          limit: 9999,
          offset: 0,
          order: 'ordering',
          sort: 'ASC',
        }}
      >
      {
        ({ loading, data }) => {
          if (loading || !data) return null
          const packagingData = data.showPackaging.packaging.filter(item => item.ordering !== -1)
          const packagingOther = data.showPackaging.packaging.filter(item => item.ordering === -1)
          const packageList = [...packagingData, ...packagingOther]
          return (
            <PackagingWrapper>
              <PackageWidthContainer>
                <H2
                  margin={isTabletS ? '0' : '0 0 32px'}
                  textAlign='left'
                  color={theme.color.primaryColor}
                >
                  รายการบรรจุภัณฑ์
                </H2>
                {
                  packageList.length <= 4 ? <PackageContainer>
                    {
                      packageList.map((v, index) => (
                        v.packageId === -1 ? <PackageCardDefault
                          onClick={() => history.push(PATH.request)}
                          data={v}
                          key={v.packageId}
                        /> : <PackageCardDefault
                          onClick={() => history.push(`${PATH.packagingDetail}/${v.packageId}`)}
                          data={v}
                          key={v.packageId}
                        />
                      ))
                    }
                  </PackageContainer> : <Slider {...{
                    className: 'package-slide',
                    infinite: true,
                    speed: 500,
                    slidesPerRow: 4,
                    swipeToSlide: true,
                    nextArrow: <ArrowIcon icon='fa fa-angle-right' />,
                    prevArrow: <ArrowIcon icon='fa fa-angle-left' />,
                    variableWidth: true,
                    adaptiveHeight: false,
                    lazyLoad: false,
                    pauseOnHover: true,
                    responsive: [
                      {
                        breakpoint: screenSize.desktop,
                        settings: {
                          rows: packagingData.length > 4 ? 2 : 1,
                          slidesPerRow: 4,
                        },
                      }, {
                        breakpoint: screenSize.laptopL,
                        settings: {
                          rows: packagingData.length > 4 ? 2 : 1,
                          slidesPerRow: 4,
                        },
                      }, {
                        breakpoint: screenSize.tablet,
                        settings: {
                          rows: packagingData.length > 4 ? 2 : 1,
                          slidesPerRow: 4,
                        },
                      }, {
                        breakpoint: screenSize.mobileXL,
                        settings: {
                          rows: packagingData.length > 2 ? 2 : 1,
                          slidesPerRow: 2,
                          nextArrow: null,
                          prevArrow: null,
                        },
                      },
                    ],
                  }}>
                    {
                      packageList.map((v, index) => (
                        <div key={index}>
                          {
                            v.packageId === -1 ? <PackageCard
                              onClick={() => history.push(PATH.request)}
                              data={v}
                              key={v.packageId}
                            /> : <PackageCard
                              onClick={() => history.push(`${PATH.packagingDetail}/${v.packageId}`)}
                              data={v}
                              key={v.packageId}
                            />
                          }
                        </div>
                      ))
                    }
                  </Slider>
                }
                <Link className='link-see-all' to={PATH.packaging}>
                  <LinkText display='block' textAlign='right' color={theme.color.primaryColor}>ดูทั้งหมด...</LinkText>
                </Link>
              </PackageWidthContainer>
            </PackagingWrapper>
          )
        }
      }
      </Query>
      <DesignServiceWrapper>
        <WidthContainer>
          <Div display='flex' flexDirection={isTablet && 'column'}>
            <Div flexBasis={isTablet ? '100%' : '60%'}>
              <Div display='inline-block' bgColor={theme.color.secondaryColor} borderRadius='20px' padding='4px 24px' margin={isTablet ? '0 0 16px' : '0 0 24px'}>
                <P color={theme.color.offWhite}>Professional Design</P>
              </Div>
              <H2 display='block' style={{ fontWeight: 'normal' }} color={theme.color.offWhite}>บริการออกแบบกล่องบรรจุภัณฑ์</H2>
              <H2 className='second-title' display='block' style={{ fontWeight: 'normal' }} color={theme.color.secondaryColor}>สร้างสรรค์ชิ้นงานที่สวยงาม</H2>
              <H5
                margin={isTablet ? '24px 0 0' : '56px 0 0'}
                color={theme.color.offWhite}
              >โดยทีมผู้เชี่ยวชาญการออกแบบกล่องบรรจุภัณฑ์ พร้อมรังสรรค์รูปแบบกล่องให้สวยงาม เพื่อเพิ่มมูลค่าของผลิตภัณฑ์และยกระดับแบรนด์สินค้า เสมือนการสวมชุดสูทให้แก่ชิ้นงานของคุณ</H5>
            </Div>
            <Div textAlign={isTablet && 'right'} margin={isTablet ? '16px -16px 0 64px' : '0 -24px 0 64px'}>
              <BlueBoxImg src={BlueBox} style={{ width: isTablet ? '180px' : 'auto' }} />
            </Div>
          </Div>
        </WidthContainer>
      </DesignServiceWrapper>
      <Div bgColor={theme.color.offWhite}>
        <WidthContainer>
          <PrintingMachineWrapper>
            <Div width={isTabletS ? '100%' : isTabletS ? '55%' : '900px'}>
              <PrintingMachineImg src={PrintingMachine} />
            </Div>
            <Div margin={isTabletS ? '24px 0 0' : '0 0 0 64px'} position='relative'>
              <H3 margin={isTabletS ? '0 0 32px' : '0 0 56px'} display='block' color={theme.color.secondaryColor}>ผลิตชิ้นงานคุณภาพสูง และรวดเร็ว</H3>
              <Line />
              <H5 color={theme.color.lightGrey}>ด้วยเทคโนโลยีที่ล้ำสมัย และกระบวนการผลิตแบบครบวงจร เราจึงสามารถผลิตกล่องบรรจุภัณฑ์ได้อย่างรวดเร็ว มีคุณภาพสูง เพื่อความประทับใจสูงสุดของลูกค้า</H5>
            </Div>
          </PrintingMachineWrapper>
        </WidthContainer>
      </Div>
      <PrintingTechnique>
        <WidthContainer style={{ textAlign: 'center' }}>
          <Div>
            <H4 margin={isTablet ? '0 0 24px' : '0 0 40px'} color={theme.color.offWhite}>บริการเทคนิคงานพิมพ์บนบรรจุภัณฑ์</H4>
            <Div display='inline-flex' moreStyle={{
              flexWrap: 'wrap',
            }}>
            {
              printingTechniqueData.map((v, i) => (
                <Div moreStyle={{ flexBasis: 'calc((100% - 224px) / 5)' }} margin={isTabletS ? i === 2 || i === 3 ? '24px 0 0' : 0 : isTablet ? 0 : '0 56px 0 0'} key={i}>
                  <PrintingImage bg={v.img} />
                  <H5 bold display='block' textAlign='center' margin='16px 0 0' color={theme.color.primaryColor}>{v.text}</H5>
                </Div>
              ))
            }
              <Div moreStyle={{ alignSelf: 'flex-end' }} width={isTablet ? '100%' : 'auto'} margin={isTablet && '32px 0 0'} textAlign={isTablet && 'center'}>
                <Link to={PATH.printingTechnique}>
                  <ButtoGhostActiveWhite fullWidth={isMobileL} color={theme.color.offWhite} ghost small={!isTablet} text='เพิ่มเติม...' />
                </Link>
              </Div>
            </Div>
          </Div>
        </WidthContainer>
      </PrintingTechnique>
      <Query
        query={SHOW_GALLERY}
        variables={{
          limit: 12,
          offset: 0,
        }}
      >
      {
        ({ loading, data }) => {
          if (loading || !data) return null
          return (
            <PortFolioWrapper>
              <H2 margin={isTabletS ? '0' : '0 0 32px'}>ผลงานของเรา</H2>
              <Slider {...{
                infinite: false,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 4,
                swipeToSlide: true,
                nextArrow: <ArrowText text='Next' />,
                prevArrow: <ArrowText text='Prev' />,
                responsive: [
                  {
                    breakpoint: screenSize.desktop,
                    settings: {
                      slidesToShow: data.showGallery.gallery.length >= 6 ? 6 : data.showGallery.gallery.length,
                      slidesToScroll: data.showGallery.gallery.length >= 6 ? 6 : data.showGallery.gallery.length,
                    },
                  }, {
                    breakpoint: screenSize.laptopL,
                    settings: {
                      slidesToShow: data.showGallery.gallery.length >= 4 ? 4 : data.showGallery.gallery.length,
                      slidesToScroll: data.showGallery.gallery.length >= 4 ? 4 : data.showGallery.gallery.length,
                    },
                  }, {
                    breakpoint: screenSize.tablet,
                    settings: {
                      dots: true,
                      slidesToShow: 1,
                      rows: 2,
                      slidesPerRow: 2,
                      slidesToScroll: 1,
                      nextArrow: null,
                      prevArrow: null,
                    },
                  },
                ],
              }}>
                {
                  data.showGallery.gallery.map((v, i) => (
                    <Div key={v.galleryId} textAlign='center' margin={isTabletS && '24px 0 0'}>
                      <Image
                        img={v.galleryFileUri}
                        onClick={() => {
                          setCurrentImage(i)
                          setOpenLightBox(true)
                        }}
                      />
                      {
                        // <H5 margin='16px 0 0' color={theme.color.lightGrey}>{v.text}</H5>
                      }
                    </Div>
                  ))
                }
              </Slider>
              <Link to={PATH.gallery}>
                <LinkText display='block' textAlign='right' color={theme.color.primaryColor}>ดูทั้งหมด...</LinkText>
              </Link>
            </PortFolioWrapper>
          )
        }
      }
      </Query>
      <Query
        query={SHOW_GALLERY}
        variables={{
          limit: 10000,
          offset: 0,
        }}
      >
      {
        ({ loading, data }) => {
          if (loading) return null
          if (!data.showGallery.success) return <p>error something</p>
          const galleryData = data.showGallery.gallery
          return (
            <Lightbox
              images={galleryData.map(v => (
                { src: v.galleryFileUri }
              ))}
              currentImage={currentImage}
              isOpen={openLightBox}
              onClickNext={() => setCurrentImage(currentImage + 1)}
              onClickPrev={() => setCurrentImage(currentImage - 1)}
              onClose={() => setOpenLightBox(false)}
              backdropClosesModal={true}
            />
          )
        }
      }
      </Query>
      <div>
        <QuotationRequestSection>
          <H1 style={{ fontWeight: 'normal' }} color={theme.color.offWhite} display='block' textAlign='center' margin={isTablet ? '0 0 32px' : '0 0 40px'}>ขอใบเสนอราคา</H1>
          <H5 color={theme.color.offWhite} display='block' textAlign='center'>สามารถร้องขอใบเสนอราคาผ่านหน้าเว็บไซต์ของเรา ลูกค้าสามารถกรอกรายละเอียดกล่องบรรจุภัณฑ์</H5>
          <H5 color={theme.color.offWhite} display='block' textAlign='center'>และยังสามารถแนบไฟล์ตัวอย่าง หรือรูปภาพสำหรับกล่องบรรจุภัณฑ์ของคุณได้</H5>
          <H5 color={theme.color.offWhite} display='block' textAlign='center' bold margin='32px 0 0'>ลูกค้าจะได้รับการติดต่อกลับภายในวันทำการถัดไป</H5>
          <Div textAlign='center' margin={isTablet ? '32px 0 0' : '40px 0 0'}>
            <Link to={PATH.request}>
              <ButtonGreenHoverWhite inverse fullWidth={isMobileL} color={theme.color.primaryColor} text='ขอใบเสนอราคา' />
            </Link>
          </Div>
        </QuotationRequestSection>
      </div>
      {
        props.showModal
        && <Query
          query={SHOW_POPUP}
        >
        {
          ({ loading, data }) => {
            if (loading) return null
            if (!data) return null
            return <Popup data={data.showPopUp.popUp} />
          }
        }
        </Query>
      }
    </ContainerWithoutHeader>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/home/index.jsx